document.addEventListener("DOMContentLoaded", (event) => {
	const hasResourcesArchive = document.querySelector(".resources-archive-wrapper");
	if (hasResourcesArchive) {
		initResourceArchive(hasResourcesArchive);
	}

	function initResourceArchive(hasResourcesArchive) {
		/**
		 * Check if the type param is set; of yes, scroll directly to the archive section
		 */
		scrollToArchive(hasResourcesArchive);

		/**
		 * Function to run when the filter buttons are clicked
		 */
		setUrlParam(hasResourcesArchive);

		/**
		 * Toggle the filter bar on mobile
		 */
		MobileToggleFilter(hasResourcesArchive);
	}

	function scrollToArchive() {
		const url = new URL(window.location.href);
		const hasType = url.searchParams.get("type");
		if (!hasType) return;
		// Scroll to archive section
		const section = hasResourcesArchive.closest(".et_pb_section");
		if (!section) return;
		section.scrollIntoView(true);
	}

	function setUrlParam(hasResourcesArchive) {
		const filterBar = hasResourcesArchive.querySelector(".resources-cat-filters-bar");
		const filterItems = filterBar.querySelectorAll("li > a");
		const url = new URL(window.location.href);
		const catType = url.searchParams.get("type");
		if (catType) {
			filterItems.forEach((link) => link.classList.remove("is-active"));
			filterBar.querySelector(`[data-type="${catType}"]`)?.classList.add("is-active");
		}

		filterBar.addEventListener("click", (e) => {
			e.preventDefault();

			if (!e.target.getAttribute("data-type")) return;
			const type = e.target.getAttribute("data-type");
			url.searchParams.set("type", type);
			window.history.replaceState({}, "", url.toString());
			filterItems.forEach((link) => link.classList.remove("is-active"));
			e.target.classList.add("is-active");
		});
	}

	function MobileToggleFilter(hasResourcesArchive) {
		const toggleBtn = hasResourcesArchive.querySelector(".resources-filter-accordion");
		const btnText = toggleBtn.querySelector("span");
		const filterBar = hasResourcesArchive.querySelector(".resources-cat-filters-bar");

		toggleBtn.addEventListener("click", (e) => {
			e.preventDefault();
			const isExpanded = toggleBtn.getAttribute("aria-expanded");

			if (isExpanded == "true") {
				toggleBtn.setAttribute("aria-expanded", false);
				filterBar.classList.remove("is-expanded");
			} else {
				toggleBtn.setAttribute("aria-expanded", true);
				filterBar.classList.add("is-expanded");
			}
		});
	}
});
